/**
 * Enum listant les diffrents types de conditions de workflow.
 */
export enum WorkflowConditionTypes {
    /* Aucune condition. */
    None = 1,
    /* Une étape doit être terminée. */
    StepCompleted = 2,
    /* Une étape doit être active. */
    StepActivated = 3,
    /* Une étape doit être dans un étape specifique. */
    StepSpecificState = 4,
    /* La valeur d'un attribut doit respecter une condition. */
    AttributeValue = 5,
    /* Les attributs obligatoire doivent être renseignés. */
    MandatoryAttributesMustBeFilledIn = 6,
    /* Certains Attributs doivent être renseignés. */
    AttributesMustBeFilledIn = 7,
    /* Expression logique. */
    LogicalExpression = 8,
}
